import PropTypes from 'prop-types';
import React from 'react';
import { SimpleFlexbox } from '../../../../../flexbox/flexbox';

const LayoutFeatureHeaderLabel = ({ children }) => {
    return (
        <SimpleFlexbox flex={1} border="right" bgColor="body_background">
            <SimpleFlexbox column display="flex" padding="all">
                {children}
            </SimpleFlexbox>
        </SimpleFlexbox>
    );
};

LayoutFeatureHeaderLabel.propTypes = {
    children: PropTypes.node
};

export { LayoutFeatureHeaderLabel };
